import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { Shield, Security, Lock, Verified } from '@mui/icons-material';

function TrustBadges({ badges, className = '' }) {
  // Default badges if none provided
  const defaultBadges = [
    { text: 'HIPAA Compliant', icon: <Shield className="text-green-600" /> },
    { text: 'Identity Verification', icon: <Security className="text-blue-600" /> },
    { text: '256-bit Encryption', icon: <Lock className="text-purple-600" /> }
  ];

  const badgesToDisplay = badges || defaultBadges;

  return (
    <Box className={`py-8 ${className}`}>
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        {badgesToDisplay.map((badge, index) => (
          <Grid item key={index}>
            <Box className="flex items-center space-x-2 px-4 py-2 bg-gray-50 rounded-lg">
              {badge.icon}
              <Typography variant="body2" className="font-medium text-gray-700 text-sm">
                {badge.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default TrustBadges;